<template>
  <section class="landing" id="landing">
    <div class="background-image slide-in from-right"></div>
    <div class="intro slide-in from-left">
      <div class="intro-text">
        <div class="container header">
          <div class="row">
            <div class="col-12 col-lg-7 col-sm-12">
              <h1>Beautyful Cosmetics</h1>
              <span class="text-2">by Barbara Knöfel</span>
            </div>
          </div>
        </div>
      </div>
      <div class="container subheader">
        <div class="row">
          <div class="col-12 col-lg-7 col-sm-12">
            <p>Herzlich Willkommen bei Beautyful Cosmetics. Mein Name ist Barbara
              Knöfel. Ich bin seit 1984 in der Welt der Kosmetik und Wellness zu Hause.</p>
            <p>Seit Mai 2018 habe ich mein Kosmetikstudio im Salon der Haarlem Friseure. Mein Kosmetikstudio
              steht für qualifizierte Behandlungen, da Beauty meine Leidenschaft ist.
              Jahrelange Erfahrung und diverse Schulungen haben mich darin gestärkt.</p>
            <p>Ihre Haut verwöhne ich mit Top Produkten der Firma Rosa Graf, mit denen ich seit über 25 Jahren
              zusammenarbeite.</p>
            <p>Genießen Sie Ihren Wohlfühlmoment.</p>
            <p><b>Ich freue mich sehr darauf, Ihren Terminwunsch entgegennehmen zu dürfen.</b></p>
            <button class="btn contact-button" v-on:click="scrollTo('contact')">kontakt aufnehmen</button>
            <div class="arrow-down three">
              <div class="fas fa-angle-double-down"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Landing",
  methods: {
    scrollTo(element) {
      // get height of header
      let header = document.getElementById('navbar').offsetHeight;
      let topOfElement = document.getElementById(element).offsetTop - header;
      window.scroll({top: topOfElement, behavior: "smooth"});
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.landing {
  padding-bottom: 0;

  h1, h3 {
    @include font-3;
    font-weight: bold;
    text-transform: lowercase;
    letter-spacing: 4px;
  }

  h3 {
    margin-top: 25px;
  }

  p {
    font-size: 19px;
  }

  .container {
    margin-top: 30px;
  }

  .intro {
    min-height: 85vh;

    @include media-breakpoint-down(md) {
      min-height: 75vh;
    }

    .intro-text {
      @include media-breakpoint-up(lg) {
        padding-top: 20px;
      }
    }
  }

  .header, .subheader {
    @include media-breakpoint-down(md) {
      text-align: center;
    }
  }

  .background-image {
    position: absolute;
    display: block;
    top: 30px;
    left: 0;
    right: 0;
    height: 100vh;
    max-width: 1920px;
    margin: 0 auto;

    @include media-breakpoint-down(md) {
      display: none;
    }

    &:after {
      content: "";
      position: absolute;
      display: block;
      top: 0;
      left: 18%;
      width: 100%;
      height: 1000px;
      background-image: url("../../../assets/images/face_front.png");
      background-repeat: no-repeat;
      background-size: auto 90%;
      background-position: right 90px;
    }
  }

  .contact-button {
    @include font-2;
    margin: 20px 0 0 0;
    border-radius: 10px;
    color: white;
    border: 2px solid white;
    white-space: nowrap;
  }

  .arrow-down {
    margin-top: 20px;
    min-height: 100px;

    @include media-breakpoint-up(lg) {
      display: none;
    }

    .fas {
      position: relative;
      font-size: 30px;
      animation: bounce .5s infinite;
      animation-direction: alternate;

      @keyframes bounce {
        0% {
          margin-top: 0;
        }

        100% {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
